module.exports = __webpack_public_path__ + "img/bImg6.e69ba6e7.png";